const community = [
	{
		path: '/community/creators',
		name: 'community-creators-list',
		component: () => import('@/views/community/push-notifications/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/features',
		name: 'community-features-list',
		component: () => import('@/views/network/blog/posts/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/ratings',
		name: 'community-ratings-list',
		component: () => import('@/views/community/ratings/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/comments',
		name: 'community-comments-list',
		component: () => import('@/views/community/comments/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/challenges',
		name: 'community-challenges-list',
		component: () => import('@/views/community/challenges/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/challenges/create',
		name: 'community-challenges-create',
		component: () => import('@/views/community/challenges/form.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/challenges/:slug/edit',
		name: 'community-challenges-edit',
		component: () => import('@/views/community/challenges/form.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/challenges/:slug/participants',
		name: 'community-challenges-participants',
		component: () => import('@/views/community/challenges/participants.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/feed-config',
		name: 'community-feed-config',
		component: () => import('@/views/community/feed-config/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/feed-promotions',
		name: 'community-feed-promotions',
		component: () => import('@/views/community/feed-promotions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
]

export default community
